import { Flex, PRINCIPAL_MAIN_HEADER_HEIGHT } from '@talos/kyoko';
import styled from 'styled-components';

export const HeaderWrapper = styled(Flex)`
  @media print {
    display: none;
  }
`;
HeaderWrapper.defaultProps = {
  gridArea: 'header',
  h: `${PRINCIPAL_MAIN_HEADER_HEIGHT}px`,
  background: 'colors.gray.main',
  w: '100%',
  flex: `0 0 ${PRINCIPAL_MAIN_HEADER_HEIGHT}px`,
  overflow: 'hidden',
};
